import styled from "styled-components";
import { mobile } from "../../../../../../ui/_themes/constants";

export const Title = styled.div`
  font-weight: 700;
  text-align: center;
  font-size: ${mobile.fontSize.m};
  letter-spacing: 0.05em;
  padding: 1em 0;
`;
